(ns frontend.components.inputs.grid
  (:require
   [frontend.components.inputs.footprint :refer [editor viewer display-string]]
   [common.localization :as loc]
   [reagent.core :as r]
   [frontend.utils :as fu]
   [common.util :as cu]
   [common.schema.registry :as registry]
   [frontend.state.current-session :as session]
   [frontend.routing :as routing]
   [common.entity :as entity]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.select-entity.view :as select-entity]
  ))

(def row-keys [:revenue :ebitda])


(defn grid-view
  [args dom-atom]
  (let [{:keys [value attribute on-blur!]} args
        tenant @session/tenant
        tenant-schema @session/tenant-schema
        shown-entities (some->> value
                                (keep (fn [id]
                                        (get @session/entities id))))
        ;; TODO - Hardcoded here for now to see if this approach works ->> in future should be in args << default from schema and tenant/user specific customizations in the future
        shown-columns [:asset/name :real-estate/property-type :real-estate/lettable-area
                       :asset/street-address :asset/city :asset/country]]
    [:div.table-responsive
     [:table.zapflow-table.table.table-striped.table-hover
      (when shown-entities
        [:thead
         [:tr
          [:th.btn-short-cell ""]
          (->> shown-columns
               (map (fn [c]
                      (let [fs (registry/get-field-schema tenant-schema c)]
                        [:th
                         {:key (str value "-" attribute "-" c)}
                         (if (= :data.type/currency-symbol (:field/data-type fs))
                           [:i.fal.fa-coin]
                           (->> fs
                                :field/translations
                                :en))])))
               (doall))
          [:th.btn-short-cell ""]]])
      [:tbody
       (->>
        shown-entities
        (map
         (fn [entity]
           ^{:key (str value "-" attribute "-row-" (:db/id entity))}
           [:tr
            [:td.btn-short-cell
             [:i.fal.fa-external-link
              {:on-click (fn [e]
                           (routing/open-entity (:db/id entity)))}]]
            (->> shown-columns
                 (map (fn [k]
                        ^{:key (str value "-" attribute "-row-" (:db/id entity) "-" (name k))}
                        [:td
                         (fu/display-data
                          tenant-schema
                          tenant
                          k
                          (registry/get-field-schema tenant-schema k)
                          entity)]))
                 (doall))
            [:td.btn-short-cell
             [:i.fal.fa-trash-alt.clickable
              {:on-click (fn [e]
                           (let [nv (disj (set value) (:db/id entity))]
                             (on-blur! e (disj (set value) (:db/id entity)))))}]]]))
        (doall))]
      (when dom-atom
        [:tfoot
         [:tr
          [:td
           {:col-span (+ 1 (count shown-columns))}
           [:a.new-value
            {:href     "#"
             :on-click (fn [e]
                         (modals/open-modal! select-entity/modal-key
                                             {:target-type    :entity.type/real-estate
                                              :create-on-fly? true
                                              :on-select!     (fn [id close-modal!]
                                                                (let [nv (conj (set value) id)]
                                                                  (on-blur! e nv close-modal!)))}))}
            (loc/tr :add)]]]])]]))

(defmethod editor :editor.type/grid
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))]
    (r/create-class
     {:display-name   "Grid"
      :reagent-render (fn [args]
                        (grid-view args dom-atom))})))

(defmethod display-string :editor.type/grid
  [args]
  (let [value (:value args)]
    (->> value
         (map (fn [id]
                (get @session/entities id)))
         (remove nil?)
         (map entity/display-string)
         (cu/tab-separated-string))))

(defmethod viewer :editor.type/grid
  [args]
  (r/create-class
   {:display-name   "grid/viewer"
    :reagent-render (fn [args]
                      (grid-view args nil))}))


